export const ui = {
  page: {
    minHeight: "100vh",
    padding: 24,
    background: "radial-gradient(circle at 20% 10%, rgba(255,140,0,0.20), transparent 45%), radial-gradient(circle at 80% 0%, rgba(255,140,0,0.10), transparent 40%), #f7f7fb",
    fontFamily: "system-ui, Segoe UI, Roboto, Arial, sans-serif",
    color: "#111827",
  },
  container: {
    maxWidth: 980,
    margin: "0 auto",
  },
  top: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 16,
    padding: "14px 18px",
    borderRadius: 16,
    backgroundColor: "rgba(255,255,255,0.75)",
    boxShadow: "0 12px 30px rgba(17,24,39,0.10)",
    backdropFilter: "blur(8px)",
  },
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    textDecoration: "none",
    color: "inherit",
  },
  logo: {
    width: 42,
    height: 42,
    borderRadius: 12,
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 18px rgba(17,24,39,0.12)",
    objectFit: "cover",
  },
  brandText: { display: "flex", flexDirection: "column", lineHeight: 1.1 },
  brandName: { fontSize: 18, fontWeight: 800, letterSpacing: 0.2 },
  brandTag: { fontSize: 12, opacity: 0.75 },

  card: {
    marginTop: 18,
    padding: 22,
    borderRadius: 18,
    backgroundColor: "rgba(255,255,255,0.85)",
    boxShadow: "0 18px 45px rgba(17,24,39,0.12)",
    backdropFilter: "blur(10px)",
  },
  h1: { margin: 0, fontSize: 34, letterSpacing: -0.4 },
  lead: { marginTop: 10, fontSize: 16, opacity: 0.85, lineHeight: 1.6 },

  row: { display: "flex", flexWrap: "wrap", gap: 12, marginTop: 16 },
  buttonPrimary: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    padding: "12px 14px",
    borderRadius: 14,
    backgroundColor: "#ff7a00",
    color: "#ffffff",
    textDecoration: "none",
    fontWeight: 800,
    boxShadow: "0 14px 26px rgba(255,122,0,0.25)",
  },
  buttonSecondary: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 10,
    padding: "12px 14px",
    borderRadius: 14,
    backgroundColor: "rgba(17,24,39,0.06)",
    color: "#111827",
    textDecoration: "none",
    fontWeight: 800,
  },

  sectionTitle: { marginTop: 22, fontSize: 15, fontWeight: 900, opacity: 0.85 },
  small: { fontSize: 13, opacity: 0.75, lineHeight: 1.6 },
  footer: { marginTop: 18, fontSize: 12, opacity: 0.65 },
  hr: { border: 0, height: 1, backgroundColor: "rgba(17,24,39,0.10)", margin: "18px 0" },

  policy: {
    h2: { marginTop: 18, fontSize: 18, fontWeight: 900 },
    h3: { marginTop: 14, fontSize: 15, fontWeight: 900 },
    p: { marginTop: 8, lineHeight: 1.65, opacity: 0.9 },
    ul: { marginTop: 8, paddingLeft: 18, lineHeight: 1.65 },
  },
};
